import React from "react";
import CancelPreShipButton from "./CancelPreShipButton";
import ShipButton from "../ShipButton";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderDTO from "@/dto/order/OrderDTO";
import OtherOperationsButton from "../OtherOperationsButton";
import FavoriteOperationsButtons from "../OtherOperationsButton/components/FavoriteOperationsButtons";

interface PreShipActionButtonsProps {
    tab: OrderTab;

    shop: ShopDTO;

    getSelectedOrders(): OrderDTO[];

    isSupplierShop: boolean;
}

const PreShipActionButtons: React.FC<PreShipActionButtonsProps> = function (props) {
    const { tab, shop, getSelectedOrders, isSupplierShop } = props;

    return (
        <>
            <CancelPreShipButton shop={shop} getSelectedOrders={getSelectedOrders} />

            <ShipButton shop={shop} tab={tab} getSelectedOrders={getSelectedOrders} />

            <FavoriteOperationsButtons
                tab={tab}
                shop={shop}
                getSelectedOrders={getSelectedOrders}
                isSupplierShop={isSupplierShop}
            />

            <OtherOperationsButton
                tab={tab}
                shop={shop}
                getSelectedOrders={getSelectedOrders}
                isSupplierShop={isSupplierShop}
            />
        </>
    );
};

export default React.memo(PreShipActionButtons);
